import { useCallback, useState } from "react";
import { toast } from "sonner";

/**
 * Return from an impersonation or a preview. `leaving` stays true until the page
 * reloads as the caller; a second call while it is set does nothing.
 */
export function useReturnToSelf(stop: (() => Promise<void>) | undefined) {
  const [leaving, setLeaving] = useState(false);
  const back = useCallback(async () => {
    if (leaving || !stop) return;
    setLeaving(true);
    try {
      await stop();
    } catch {
      setLeaving(false);
      toast.error("Failed to return to your account. Please try again.");
    }
  }, [leaving, stop]);
  return { leaving, back };
}
